import { MealToDayDayInterface } from '../../../../../shared/type/mealToDay.type';

export interface Allergen {
  name: string;
  formalNumber: number | null;
}

export interface MealRow {
  when: string;
  courseName: string;
  mealName: string;
  description: string;
  allergens: Allergen[];
  mealToDayId: number | null;
  pdfMenu: any;
  workingDay: boolean;
  countForDate: number;
}

export function flattenMealPlanData(data: MealToDayDayInterface[]): MealRow[] {
  const allRows: Omit<MealRow, 'countForDate'>[] = [];

  data.forEach((day) => {
    if (!day.workingDay) {
      allRows.push({
        when: day.when,
        courseName: '',
        mealName: '',
        description: '',
        allergens: [],
        mealToDayId: 0,
        pdfMenu: day.pdfMenu,
        workingDay: false
      });
    } else if (day.pdfMenu !== null) {
      allRows.push({
        when: day.when,
        courseName: '',
        mealName: '',
        description: '',
        allergens: [],
        mealToDayId: 0,
        pdfMenu: day.pdfMenu,
        workingDay: true
      });
    } else {
      day.mealsToCourse?.forEach((meal) => {
        allRows.push({
          when: day.when,
          courseName: meal.courseName,
          mealName: meal.mealDto?.name || '',
          description: meal.mealDto?.description || '',
          allergens: meal.mealDto?.allergens || [],
          mealToDayId: meal.mealToDayId,
          pdfMenu: day.pdfMenu,
          workingDay: day.workingDay
        });
      });
    }
  });

  // Dodajemy countForDate
  const dateCounts = allRows.reduce<Record<string, number>>((acc, row) => {
    acc[row.when] = (acc[row.when] || 0) + 1;
    return acc;
  }, {});

  const withCounts: MealRow[] = allRows.map((row) => ({
    ...row,
    countForDate: dateCounts[row.when]
  }));

  return withCounts;
}
